export default {"src":"/_next/static/media/clearance.55abfcc1.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};